import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","width":"fit-content"} }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "mobile-quote-sender"
}
const _hoisted_4 = { class: "max-double-line" }

import vue from '../../../../../adapter-vue';
import {
  TUIStore,
  StoreName,
  IMessageModel,
  TUITranslateService,
} from '../../../../../@aidesk/uikit-engine';
import {
  getBoundingClientRect,
  getScrollInfo,
} from '@tencentcloud/universal-api';
import { isH5,isPC } from '../../../../../utils/env';
import {
  Toast,
  TOAST_TYPE,
} from '../../../../../components/common/Toast/index-web';
import {
  ICloudCustomData,
  IQuoteContent,
  MessageQuoteTypeEnum,
} from './interface.ts';
import { transformTextWithKeysToEmojiNames } from '../../../emoji-config';
export interface IProps {
  message: IMessageModel;
}

export interface IEmits {
  (e: 'scrollTo', scrollHeight: number): void;
  (e: 'blinkMessage', messageID: string | undefined): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index-web',
  props: {
    message: { default: () => ({} as IMessageModel) }
  },
  emits: ["scrollTo", "blinkMessage"],
  setup(__props: any, { emit: __emit }) {

const { computed, ref, onMounted } = vue;

const emits = __emit;
const props = __props;

let selfAddValue = 0;
const messageQuoteText = ref<string>('');
const hasQuoteContent = ref(false);
const messageQuoteContent = ref<IQuoteContent>({} as IQuoteContent);
const quoteMessageSender = ref<string>('');

const isMessageRevoked = computed<boolean>(() => {
  try {
    const cloudCustomData: ICloudCustomData = JSON.parse(
      props.message?.cloudCustomData || '{}',
    );
    const quotedMessageModel = TUIStore.getMessageModel(
      cloudCustomData.messageReply.messageID,
    );
    return quotedMessageModel?.isRevoked;
  } catch (error) {
    return true;
  }
});

onMounted(() => {
  try {
    const cloudCustomData: ICloudCustomData = JSON.parse(
      props.message?.cloudCustomData || '{}',
    );
    hasQuoteContent.value = Boolean(cloudCustomData.messageReply);
    if (hasQuoteContent.value) {
      messageQuoteContent.value = cloudCustomData.messageReply;
      messageQuoteText.value = performQuoteContent(messageQuoteContent.value);
    }
  } catch (error) {
    hasQuoteContent.value = false;
  }
});

function performQuoteContent(params: IQuoteContent) {
  let messageKey: string = '';
  let quoteContent: string = '';
  const quoteMessage = getQuoteMessage(params.messageID);
  switch (params.messageType) {
    case MessageQuoteTypeEnum.TYPE_TEXT:
      messageKey = '[文本]';
      break;
    case MessageQuoteTypeEnum.TYPE_CUSTOM:
      messageKey = '[自定义消息]';
      break;
    case MessageQuoteTypeEnum.TYPE_IMAGE:
      messageKey = '[图片]';
      break;
    case MessageQuoteTypeEnum.TYPE_SOUND:
      messageKey = '[音频]';
      break;
    case MessageQuoteTypeEnum.TYPE_VIDEO:
      messageKey = '[视频]';
      break;
    case MessageQuoteTypeEnum.TYPE_FILE:
      messageKey = '[文件]';
      break;
    case MessageQuoteTypeEnum.TYPE_LOCATION:
      messageKey = '[地理位置]';
      break;
    case MessageQuoteTypeEnum.TYPE_FACE:
      messageKey = '[动画表情]';
      break;
    case MessageQuoteTypeEnum.TYPE_GROUP_TIPS:
      messageKey = '[群提示]';
      break;
    case MessageQuoteTypeEnum.TYPE_MERGER:
      messageKey = '[聊天记录]';
      break;
    default:
      messageKey = '[消息]';
      break;
  }
  if (params.messageType === MessageQuoteTypeEnum.TYPE_CUSTOM ||
      params.messageType === MessageQuoteTypeEnum.TYPE_TEXT ||
      params.messageType === MessageQuoteTypeEnum.TYPE_MERGER) {
    quoteContent = params.messageAbstract;
  }
  quoteMessageSender.value = !quoteMessage ? messageQuoteContent.value.messageSender : (quoteMessage.nick || quoteMessage.from);
  return quoteContent
    ? quoteContent
    : TUITranslateService.t(`TUIChat.${messageKey}`);
}

function getQuoteMessage(messageID: string) {
  const currentMessageList = TUIStore.getData(StoreName.CHAT, 'messageList');
  let quoteMessage = currentMessageList.find(
    message => message.ID === messageID,
  );
  return quoteMessage;
}

async function scrollToOriginalMessage() {
  if (isMessageRevoked.value) {
    return;
  }
  const originMessageID = messageQuoteContent.value?.messageID;
  const currentMessageList = TUIStore.getData(StoreName.CHAT, 'messageList');
  const isOriginalMessageInScreen = currentMessageList.some(
    message => message.ID === originMessageID,
  );
  if (originMessageID && isOriginalMessageInScreen) {
    try {
      const scrollViewRect = await getBoundingClientRect(
        '#messageScrollList',
        'messageList',
      );
      const originalMessageRect = await getBoundingClientRect(
        '#tui-' + originMessageID,
        'messageList',
      );
      const { scrollTop } = await getScrollInfo(
        '#messageScrollList',
        'messageList',
      );
      const finalScrollTop
        = originalMessageRect.top
        + scrollTop
        - scrollViewRect.top
        - (selfAddValue++ % 2);
      const isNeedScroll = originalMessageRect.top < scrollViewRect.top;
      if (window) {
        const scrollView = document.getElementById('messageScrollList');
        if (isNeedScroll && scrollView) {
          scrollView.scrollTop = finalScrollTop;
        }
      }
      emits('blinkMessage', originMessageID);
    } catch (error) {
      console.error(error);
    }
  } else {
    Toast({
      message: TUITranslateService.t('TUIChat.无法定位到原消息'),
      type: TOAST_TYPE.WARNING,
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasQuoteContent))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
          'reference-content': true,
          reverse: __props.message.flow === 'out',
          in:__props.message.flow === 'in',
          isMobile: _unref(isH5),
          isPc: _unref(isPC),
        }),
          onClick: scrollToOriginalMessage
        }, [
          (_unref(isMessageRevoked))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_unref(isPC) ? 'revoked-text' : '')
              }, _toDisplayString(_unref(TUITranslateService).t("TUIChat.引用内容已撤回")), 3))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_unref(isH5))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(quoteMessageSender)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(isPC) ? _unref(quoteMessageSender) + ": "+ _unref(transformTextWithKeysToEmojiNames)(_unref(messageQuoteText)) : _unref(transformTextWithKeysToEmojiNames)(_unref(messageQuoteText))), 1)
              ]))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})